module.exports = __webpack_public_path__ + "media/images/color_admin_v3/login-bg/bg-2-bc9c455df22487db671379fa0223e662.jpg";